import React, { useState,useEffect,useCallback} from 'react';
import { AppProvider,FormLayout,TextField,PageActions,Layout,Form } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import Api from './Services/CommonServices';
// import { environment } from './environments/environment.prod';
const api = new Api();
// let storeUrl = "";

export function VerifyShop() {
const [shopUrl, setShopUrl] = useState('');
var queryParams = {};
const handleChange = useCallback((newValue) => setShopUrl(newValue), []);

useEffect(() => {
  getStoreUrl();
}, []);

async function generateAuthUrl() {
    api.generateAuthUrl(shopUrl)
    .then(res => {
      // console.log(`res = ${res}`);
      window.open(res, '_top');
    }, err => {
      console.log(`err = ${JSON.stringify(err)}`);
    });
  }
  const handleFormSubmit =(evt) =>{
    evt.preventDefault();
    getStarted()
    // console.log(shopUrl);
  }

async function getStoreUrl()
{
 console.log(`queryparams = ${JSON.stringify(api.QueryStringToJSON())}`);
 queryParams = api.QueryStringToJSON();
 if (queryParams && queryParams.shop) {
  setShopUrl(queryParams.shop);
  //  console.log(`shopUrl = ${shopUrl}`);
 }
}
async function getStarted() {
    shopUrl.trim();
    generateAuthUrl();
  }
    return (

      <AppProvider i18n={enTranslations}>
      <Form onSubmit={handleFormSubmit}>
      <Layout>
      <Layout.AnnotatedSection>
      <FormLayout>
      <TextField label="Enter your store url" helpText="Shop Domain to get started" id="storeName" value={shopUrl} onChange={handleChange}/>
      <Layout.Section>
      <PageActions
        primaryAction={{
        content: 'Get Started',
        submit: true,
        }}
      />
      </Layout.Section>
      </FormLayout>
      </Layout.AnnotatedSection>
      </Layout>
      </Form>
      </AppProvider>


    );
  }

  export default VerifyShop
